import React, { FC } from 'react';
import { map } from 'lodash';
import { Trans } from '@lingui/macro';
import { Text, Box } from '@bechtel/gds';
import { MilestoneStatus, CommodityStatusLegendProps } from './types';
import { PatternStyled, WeldPatternStyled } from './styled';
import { MilestoneStatusMessages, WeldStatusMessages } from '~/components';
import { useLingui } from '@lingui/react';
import { CommodityStatusCode, MilestoneStatusCode } from '@bechtel/types';

export const CommodityStatusLegend: FC<CommodityStatusLegendProps> = ({ isWeldCommodity }) => {
  const { i18n } = useLingui();
  const WeldMilestoneStatus = {
    REQUESTED: MilestoneStatusCode.REQUESTED, ...MilestoneStatus
  };
  return (
    <Box alignItems={{ sm: 'center' }} justifyContent={{ sm: 'flex-start' }} data-testid="commodity-status-legend">
      {map(isWeldCommodity ? WeldMilestoneStatus : MilestoneStatus, (status) => {
        return (
          <Box alignItems={{ sm: 'center' }} mr={{ sm: '600' }} key={status}>
            {isWeldCommodity ? <WeldPatternStyled status={status} /> : <PatternStyled status={status} />}
            <Text size="300" color="grey.600">
              {isWeldCommodity ? i18n._(WeldStatusMessages[(status == MilestoneStatusCode.REQUESTED ? CommodityStatusCode.FITUP_REQUESTED : status)])
                : <Trans id={MilestoneStatusMessages[status].id} />}
            </Text>
          </Box>
        );
      })
      }
    </Box>
  );
};
